import { extractDomainFromUrl, getFaviconUrl } from 'src/services/helpers/util.helper'

const LAZY_EMAIL_SHAPE = /.+@.+\..+/
export const REQUIRED_EMAIL_QUASAR_RULES = [requiredEmailQuasarRule]
/**
 * @param {unknown} grants
 * @returns {grants is Record<string, unknown>}
 */
export function hasValidGrants(grants) {
  return (
    grants !== null &&
    typeof grants === 'object' &&
    !Array.isArray(grants) &&
    Object.keys(grants).length > 0
  )
}

/** @param {Record<string, unknown> | null | undefined} grants @returns {string[]} */
export function getGrantKeysFromPayload(grants) {
  if (!hasValidGrants(grants)) {
    return []
  }
  return Object.keys(grants)
}

/** @param {Record<string, unknown> | null | undefined} grants @returns {{ grantId: string, grant: unknown, faviconUrl: string, domain: string }[]} */
export function getGrantEntriesFromPayload(grants) {
  if (!hasValidGrants(grants)) {
    return []
  }
  return Object.entries(grants).map(([grantId, grant]) => {
    const domain = extractDomainFromUrl(grant?.website)
    return {
      grantId,
      grant,
      faviconUrl: getFaviconUrl(domain),
      domain,
    }
  })
}

/**
 * Shared Quasar `q-input` rule fns: `(val) => true | string`.
 */

/** Required field + simple email shape (lazy UX-style check, not RFC validation). */
export function requiredEmailQuasarRule(val) {
  const v = (val ?? '').trim()
  if (!v) {
    return 'Enter your email'
  }
  if (!LAZY_EMAIL_SHAPE.test(v)) {
    return 'Enter a valid email'
  }
  return true
}
